/**
 * Referral param and cookie: single source of truth for theme and React.
 * - Sets a 30-day cookie when ?referral= is present in the URL.
 * - Exposes getReferralValue() for reading the current referral (URL param first, then cookie).
 */
(function () {
  const REFERRAL_COOKIE_NAME = 'referral';
  const REFERRAL_COOKIE_DAYS = 30;

  function setReferralCookie(value) {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + REFERRAL_COOKIE_DAYS * 24 * 60 * 60 * 1000);
    document.cookie = `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(value)}; expires=${expirationDate.toUTCString()}; path=/`;
  }

  function getReferralFromCookie() {
    const row = document.cookie.split('; ').find((r) => r.startsWith(REFERRAL_COOKIE_NAME + '='));
    if (!row) return '';
    const value = row.split('=').slice(1).join('=').trim();
    try {
      return value ? decodeURIComponent(value) : '';
    } catch {
      return value || '';
    }
  }

  // Expose setter on window for React and other scripts
  window.setReferralCookie = setReferralCookie;

  // On load: if URL has ?referral=, persist to cookie
  const urlParams = new URLSearchParams(window.location.search);
  const referralParam = urlParams.get('referral');
  if (referralParam) {
    setReferralCookie(referralParam);
  }

  /**
   * Returns the current referral value: URL param if present, otherwise cookie, otherwise ''.
   * Use this in product-form, Club Configurator, and Acuity scheduler instead of reading the cookie directly.
   */
  window.getReferralValue = function getReferralValue() {
    const param = new URLSearchParams(window.location.search).get('referral');
    if (param) return param;
    return getReferralFromCookie();
  };
})();
